(function () {
  'use strict';

  function customCarousel (Common) {
    function link (scope, el, attr, ctrl) {
      el.addClass('parcel-selector');

      const OPTION_WIDTH = 207;
      const PADDING_OFFSET = 10;

      function isUsingScroll () {
        const parcelsWrapper = el[0].getElementsByClassName('cc-container')[0];
        const overflowX = window.getComputedStyle(parcelsWrapper).overflowX;

        return overflowX === 'scroll';
      }

      function scrollToItemWithIndex (index) {
        const parcelsWrapper = el[0].getElementsByClassName('cc-container')[0];
        const width = parcelsWrapper.offsetWidth;

        parcelsWrapper.scrollLeft = index * width - ((width / 2) - (width / 2));
      }

      function getNumVisibleParcels (width, paddingOffset) {
        const parcelsWrapper = el[0].getElementsByClassName('cc-container')[0];
        width = parcelsWrapper.offsetWidth;

        return width / (width + paddingOffset);
      }

      function sideScroll (direction, speed, distance, step) {
        const element = document.getElementById('parcelSelector');
        let scrollAmount = 0;

        const slideTimer = setInterval(function () {
          if (direction === 'left') {
            element.scrollLeft -= step;
          } else {
            element.scrollLeft += step;
          }

          scrollAmount += step;

          if (scrollAmount >= distance) {
            window.clearInterval(slideTimer);
          }

        }, speed);
      }


      function moveLeft () {
        setOffset(scope.numVisibleParcels * OPTION_WIDTH - (OPTION_WIDTH + PADDING_OFFSET / 2));
      }

      function moveRight () {
        setOffset(-scope.numVisibleParcels * (OPTION_WIDTH) + (OPTION_WIDTH + PADDING_OFFSET / 2));
      }

      function moveLeftMobile () {
        sideScroll('left', 3, OPTION_WIDTH, 10);
      }

      function moveRightMobile () {
        sideScroll('right', 3, OPTION_WIDTH, 10);
      }


      function isFurthestLeft () {
        return scope.offset === 0;
      }

      function isFurthestRight () {
        return scope.offset === (scope.options ? ((scope.options.length - scope.numVisibleParcels)
          * -OPTION_WIDTH + PADDING_OFFSET) : 0);
      }

      function setOffset (delta) {
        let res = scope.offset + delta;
        const minOffset = scope.options ? (scope.options.length - scope.numVisibleParcels)
          * -OPTION_WIDTH + PADDING_OFFSET : 0;

        res = Math.max(res, minOffset);
        res = Math.min(res, 0);

        scope.offset = res;
      }

      function activate () {
        scope.offset = 0;
        scope.numVisibleParcels = 0;
        scope.moveLeft = moveLeft;
        scope.moveRight = moveRight;
        scope.moveLeftMobile = moveLeftMobile;
        scope.moveRightMobile = moveRightMobile;
        scope.isFurthestLeft = isFurthestLeft;
        scope.isFurthestRight = isFurthestRight;

        scope.isUsingScroll = isUsingScroll;
        scope.scrollToItemWithIndex = scrollToItemWithIndex;
        scope.getNumVisibleParcels = getNumVisibleParcels;
        scope.language = pnTopbar.language;

        scope.$on('changeLanguage', function (events, language) {
          scope.language = language;
        });
      }

      activate();

    }

    return {
      'restrict': 'E',
      'templateUrl': 'components/shared/custom-carousel/custom-carousel.html',
      'link': link,
      'scope': {
        'options': '=',
        'selectedOption': '=',
        'selectOption': '='
      }
    };
  }

  angular.module('web2print.shared')
    .directive('customCarousel', customCarousel);

  customCarousel.$inject = ['Common'];
})();
